import PropTypes from 'prop-types';
import Grid from 'infrastructure/js/components/Grid/gridWrapper';
import {gridsNames} from '../../../enums/gridsNames';
import {filterTypes} from 'infrastructure/js/enums/filterTypes';
import LabelWithTooltipCell from '../../Common/CustomGridCells/LabelWithTooltipCell/labelWithTooltipCell';
import DateTimeHelper from 'infrastructure/js/utils/dateTimeHelper';
import GridHelper from 'infrastructure/js/components/Grid/Utils/gridHelper';
import {enumTypes, getEnumLabel} from '../../../utils/enumHelper';
import LinkCell from '../../Common/CustomGridCells/LinkCell/linkCell';
import useLabels from 'infrastructure/js/hooks/useLabels';
import CocTestResultCell from '../../Common/CustomGridCells/CoCTestResultCell/cocTestResultCell';

require('./cocTestsViewGrid.scss');

const filterConfig = [
  {fieldName: 'name', filterName: 'testName', getOptions: true},
  {fieldName: 'type', filterName: 'testType', getOptions: true},
  {fieldName: 'lastUpdated', filterName: 'lastUpdated', getOptions: true},
  {fieldName: 'result', filterName: 'testResult', getOptions: true},
];

export default function CocTestsViewGrid ({
                                            actions,
                                            history,
                                            match,
                                          }) {

  const labels = useLabels('mat.views.coc.cocTests.grid.');

  const columnsConfig = [
    {
      fieldName: 'name',
      title: labels.get('columns.testName.title'),
      filterType: filterTypes.MULTI_SELECT,
      filterName: 'testName',
      columnOptions: {
        cellComponent: LinkCell,
        valueGetter: (params) => {
          return {
            label: params.data?.name,
            onClickHandler: () => {
              history.push(`${match.url}/cocTestForm/${params.data?.id}`);
            }
          };
        }
      }
    },
    {
      fieldName: 'type',
      title: labels.get('columns.testType.title'),
      filterType: filterTypes.MULTI_SELECT,
      filterName: 'testType',
      columnOptions: {
        cellComponent: LabelWithTooltipCell,
        valueGetter: (params) => {
          return getEnumLabel(enumTypes.TEST_TYPE)(params.data?.type);
        }
      }
    },
    {
      fieldName: 'lastUpdated',
      title: labels.get('columns.lastUpdate.title'),
      filterType: filterTypes.HORIZON,
      filterName: 'lastUpdated',
      width: 150,
      columnOptions: {
        cellComponent: LabelWithTooltipCell,
        valueGetter: (params) => {
          return params.data ? DateTimeHelper.DateFormat(params.data?.lastUpdated?.epochDateTime * 1000) : '';
        },
        headerComponentParams: GridHelper.getDateFormatHeaderIcon(),
      }
    },
    {
      fieldName: 'result',
      title: labels.get('columns.testResult.title'),
      filterType: filterTypes.MULTI_SELECT,
      filterName: 'testResult',
      columnOptions: {
        cellComponent: CocTestResultCell,
      }
    },
    {
      fieldName: 'localizedFailureReason',
      title: labels.get('columns.failureReason.title'),
      filterType: filterTypes.NONE,
      columnOptions: {
        sortable: false,
        cellComponent: LabelWithTooltipCell,
      }
    },
  ];

  return (
    <div className="coc-tests-view-grid">
      <Grid gridName={gridsNames.COC_TESTS}
            columnsConfig={columnsConfig}
            actions={actions}
            filterConfig={filterConfig}
            gridProps={
              {
                checkboxSelection: false
              }
            }
      >
      </Grid>
    </div>
  );
}

CocTestsViewGrid.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};
